import { VERNACULAR_DEFAULT_MESSAGES } from "constants/vernacularConstants";


interface ValidationReturnType{ error: string, hasError: boolean, isLatinDetected?: boolean };
/**
* validation funciton for phoneNumber field
* @param phoneNumber of type string or null
*/
export const validatePhoneNumber = (phoneNumber: string | null, errors?: {required: string, invalid: string}) : ValidationReturnType => {
  let error = "";
  let hasError = false;
  if (!phoneNumber) {
    error = (errors && errors.required) || VERNACULAR_DEFAULT_MESSAGES.THIS_FIELD_IS_REQUIRED;
    hasError = true;
  } else if (!/^\d{10}$/.test(phoneNumber) || parseInt(phoneNumber.charAt(0)) < 6) {
    error = (errors && errors.invalid) || VERNACULAR_DEFAULT_MESSAGES.PHONE_NUMBER_NOT_VALID;
    hasError = true;
  } else {
    error = "";
  }

  return {
    error,
    hasError,
  };
};
